import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        color: theme.palette.secondary.main,
        margin: '20px 15px 0 15px',
        '& p': {
            marginBottom: theme.spacing(2),
            textAlign: 'justify'
        }
    },
    title: {
        fontSize: 36,
        textAlign: 'center',
        marginBottom: theme.spacing(3)
    },
    topic: {
        fontWeight: 'bold',
        fontStyle: 'italic'
    },
    identedText: {
        paddingLeft: theme.spacing(4)
    },
    footer: {
        paddingBottom: 20
    }
}));

export default useStyles;